import React from 'react'
import { useInView } from 'react-intersection-observer'

export default function Announcement (props) {
  const [slideUpRef, isInView] = useInView({ triggerOnce: true })
  const { title, body } = props
  return (
    <>
      <aside
        ref={slideUpRef}
        className={`row scholarship-announcement animation ${
          isInView ? 'slide-up' : ''
        } `}
      >
        <div className='col-10 offset-1 text-lg-center'>
          <div className='content'>
            <h2 className='heading2'>{title}</h2>
            <div
              className='p-body'
              dangerouslySetInnerHTML={{ __html: body }}
            />
            <hr className='shortline' />
          </div>
        </div>
      </aside>
      <style jsx>{`
        .p-body {
          max-width: 884px;
          margin: 0 auto;
          padding-top: 15px;
        }
      `}</style>
    </>
  )
}
